import BrowsingHistoryProductsCarousel from './BrowsingHistoryProductsCarousel';
import { connect } from 'react-redux';

import { analyticsActions } from 'src/analytics/store';

const mapDispatchToProps = dispatch => ({
  fireProductClickEvent: data => dispatch(analyticsActions.productClick(data)),
  fireProductImpressionEvent: data => dispatch(analyticsActions.productImpression(data))
});

export default connect(null, mapDispatchToProps)(BrowsingHistoryProductsCarousel);